import { withIcon } from "../Icon"

export const IconTickCircle = withIcon(
  '<path fill="currentColor" fill-rule="evenodd" d="M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm2.239 5.73-3.387 3.853-1.09-1.241a.511.511 0 0 0-.402-.18.511.511 0 0 0-.402.18.667.667 0 0 0-.158.457c0 .185.053.338.158.457l1.492 1.698a.52.52 0 0 0 .402.196.52.52 0 0 0 .402-.196l3.788-4.31a.667.667 0 0 0 .158-.457.667.667 0 0 0-.158-.457.511.511 0 0 0-.402-.18.511.511 0 0 0-.401.18Z" clip-rule="evenodd"/>',
)
